/**
 * Sorts an array of objects where field must be a key of that object and order must be true or false.
 *
 * @param {*} array
 * @param {*} field
 * @param {*} order
 */
export function sortArray(array, field, order) {
  return array.sort(function (a, b) {
    if (a[field].toLowerCase() > b[field].toLowerCase()) {
      return order ? 1 : -1;
    }
    if (a[field].toLowerCase() < b[field].toLowerCase()) {
      return order ? -1 : 1;
    }
    return 0;
  });
}
//# sourceMappingURL=sortUtil.js.map
